import CommonConstants from "../constants";

export const Iso = () => {
  return (
    <img src={CommonConstants.assets.iso} alt="logo iso" className="w-32" />
  );
};